<ng-select
  app-select
  [formControl]="dataCtrl"
  [placeholder]="'trilhas.categoria.selecione-uma-categoria' | translate"
  [items]="data$ | async"
  bindValue="id"
  bindLabel="nome"
  [multiple]="false"
  [clearable]="false"
>
</ng-select>
